import React from "react";
import { useLanguage } from "../context/LanguageContext";

const SizeFitSection = () => {
  const { language } = useLanguage();
  
  const content = {
    sl: {
      label: "SE PREPOZNATE?",
      title: "Preveliki, da bi vse urejali sami.",
      titleHighlight: "Premajhni za lastnega računovodjo v podjetju?",
      description: "Ravno za vas smo tu: izkušena ekipa in osebni skrbnik — za delček stroška zaposlenega računovodje.",
      cards: [
        {
          label: "LASTNI RAČUNOVODJA",
          title: "Plača in vsi stroški zaposlitve",
          text: "Dopust, bolniška, nadomeščanje — in vse znanje v eni glavi.",
          dark: false
        },
        {
          label: "GENERAL LEDGER",
          title: "Ekipa, ki ne gre na dopust hkrati",
          text: "Osebni skrbnik, ki vas pozna, in ekipa za njim, ko ga ni.",
          dark: true
        },
        {
          label: "VI",
          title: "En fiksen mesečni znesek",
          text: "Brez stroškov zaposlitve, brez skrbi za nadomeščanje.",
          dark: false
        }
      ]
    },
    en: {
      label: "SOUND LIKE YOU?",
      title: "Too big to do it all yourself.",
      titleHighlight: "Too small for an in-house accountant?",
      description: "That's exactly who we're here for: an experienced team and a dedicated account manager — for a fraction of the cost of an employed accountant.",
      cards: [
        {
          label: "IN-HOUSE ACCOUNTANT",
          title: "A salary plus every cost of employment",
          text: "Holidays, sick leave, cover — and all the know-how in one head.",
          dark: false
        },
        {
          label: "GENERAL LEDGER",
          title: "A team that never goes on holiday all at once",
          text: "A dedicated account manager who knows you, and a team behind them when they are away.",
          dark: true
        },
        {
          label: "YOU",
          title: "One fixed monthly fee",
          text: "No employment costs, no worrying about cover.",
          dark: false
        }
      ]
    }
  };
  
  const t = content[language] || content.sl;
  
  return (
    <section className="px-6 lg:px-[120px] pt-24 lg:pt-32 bg-[#F6F2EA]" data-testid="size-fit-section">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12">
        {/* Header */}
        <div className="flex flex-col items-center text-center gap-5 animate-on-scroll">
          <span className="text-[13px] font-bold tracking-[2.5px] text-[#7A5B28]">{t.label}</span>
          <h2 className="font-serif text-3xl lg:text-[64px] leading-[1.02] tracking-[-1px] max-w-[1080px]">
            {t.title} <span className="italic">{t.titleHighlight}</span>
          </h2>
          <p className="text-lg leading-[1.6] text-[#4E5359] max-w-[720px]">{t.description}</p>
        </div>
        
        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {t.cards.map((card, index) => (
            <div 
              key={card.label}
              className={`p-9 flex flex-col gap-3 animate-on-scroll delay-${index + 1} ${
                card.dark 
                  ? 'bg-[#0E1114] text-[#F4EFE6] border-[#0E1114]' 
                  : 'bg-[#FFFDF8] text-[#15181C] border border-[#E2DACB]'
              }`}
              data-testid={`size-fit-card-${index + 1}`}
            >
              <span className={`text-xs font-bold tracking-[2px] ${card.dark ? 'text-[#C9A462]' : 'text-[#7A5B28]'}`}>
                {card.label}
              </span>
              <span className="font-serif text-[30px] leading-[1.1]">{card.title}</span>
              <span className={`text-[15px] leading-[1.55] ${card.dark ? 'text-[#B9B3A7]' : 'text-[#4E5359]'}`}>
                {card.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SizeFitSection;
